import React, { useState } from "react";
import PPEDetetction from "../Assets/ppedetection.png";
import Collision from "../Assets/CollisionCapture.png";
import Intrusion from "../Assets/intrusion.png";

// Sample data for each risk type with imported GIFs
const riskData = [
  {
    title: "PPE Detection",
    description: [
      "The Contracto PPE detection system identifies areas where different safety and personal protective equipment to be used. ",
      "It monitors people on the usage of PPEs and compliance to site specific standards for safety gear.",
      "Highlights to the management on the breaches and potential risks involved",
      "Provides insights based on collected data – site, people and equipment",
    ],
    mediaSrc: PPEDetetction,
  },
  {
    title: "Intrusion Detection",
    description: [
      "The Contracto Intrusion detection system marks restricted areas in the site with potential risk to Human and equipment",
      "Any unauthorized entry or infringement is highlighted and triggers are sent to management for action.",
      "Data Insights are provided on Non-Compliance and Risk Mitigation",
    ],
    mediaSrc: Intrusion,
  },
  {
    title: "Collision Avoidance",
    description: [
      "Work sites where multiple equipment is in operation and man power movement, accidents / near misses are a common occurrence.",
      "The Contracto Collision avoidance system marks boundaries around each equipment and work areas through AI and ensures alarm is triggered when at risk. In unavoidable or hazardous situations, machines would automatically be stopped through “The Contracto” tool.",
      "Data Intelligence is provided for remedial actions.",
    ],
    mediaSrc: Collision,
  },
];

const RiskTypes = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="flex flex-col items-center bg-white py-12 px-4 lg:px-0">
      {/* Title */}
      <h1 className="text-5xl font-semibold mt-10 mb-10 pb-5 text-center">Site Safety Management Product Portfolio</h1>

      {/* Content Card */}
      <div className="bg-white rounded-2xl p-6 lg:p-8 flex flex-col max-w-6xl w-full h-auto min-h-[500px] shadow-lg">
        
        {/* Tabs with Indicator Bar */}
        <div className="relative w-full mb-6">
          <div className="flex justify-around text-center text-lg lg:text-xl font-semibold text-gray-500">
            {["PPE Detection", "Intrusion Detection", "Collision Avoidance"].map((tab, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`flex-1 pb-6 ${activeIndex === index ? "text-seablue" : ""}`}
              >
                {tab}
              </button>
            ))}
          </div>
          
          {/* Continuous Light Bar */}
          <div className="absolute bottom-0 left-0 w-full h-2 bg-whiteblue rounded-full"></div>
          
          {/* Active Segment Indicator */}
          <div
            className="absolute bottom-0 h-2 bg-seablue rounded-full transition-all duration-300 ease-in-out"
            style={{
              width: `${100 / riskData.length}%`,
              transform: `translateX(${activeIndex * 100}%)`,
            }}
          ></div>
        </div>

        {/* Active Content Section */}
        <div className="flex flex-col lg:flex-row items-center lg:items-start p-0 bg-white rounded-lg my-5 h-auto">
          {/* Media Section: Display GIF */}
          <div className="lg:w-3/5 w-full flex justify-center lg:justify-start mb-4 lg:mb-0">
            <img
              src={riskData[activeIndex].mediaSrc}
              alt={riskData[activeIndex].title}
              className="rounded-lg w-full h-auto max-h-[350px] object-cover" 
            />
          </div>

          {/* Text Section */}
          <div className="lg:w-2/5 w-full lg:pl-6 max-w-md text-center lg:text-left">
            <h1 className="text-4xl lg:text-4xl font-bold mb-4 lg:mb-6">{riskData[activeIndex].title}</h1>
            
            {/* Bullet Point Description List */}
            <ul className="text-md lg:text-md font-semibold text-gray-700 text-left mb-4 space-y-2">
              {riskData[activeIndex].description.map((point, i) => (
                <li key={i} className="list-disc list-inside">{point}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskTypes;
